import about from "data/languages/lang_about.json";
import footer from "data/languages/lang_footer.json";
import navbar from "data/languages/lang_navbar.json";
import newhome from "data/languages/lang_new_home.json";
import ucLanding from "data/languages/lang_omu_landing_uc.json";
import faq from "data/languages/lang_faq.json";
import leadsForm from "data/languages/lang_omu_leads_form.json";
import borrowerLanding from "data/languages/lang_omu_landing_borrower.json";
import dataDeletion from "data/languages/lang_data_deletion.json";
import login from "data/languages/lang_login.json";
import register from "data/languages/lang_register.json";
import kyb from "data/languages/lang_kyb.json";
import omuDashboard from "data/languages/lang_omu_dashboard.json";
import omuInvoice from "data/languages/lang_omu_invoice.json";

const initialState = {
  selected: "id",
  languageData: {
    id: {
      navbar: navbar.id,
      about: about.id,
      footer: footer.id,
      newhome: newhome.id,
      ucLanding: ucLanding.id,
      faq: faq.id,
      leadsForm: leadsForm.id,
      borrowerLanding: borrowerLanding.id,
      dataDeletion: dataDeletion.id,
      login: login.id,
      register: register.id,
      kyb: kyb.id,
      omuDashboard: omuDashboard,
      omuInvoice: omuInvoice.id,
    },
    en: {
      navbar: navbar.en,
      about: about.en,
      footer: footer.en,
      newhome: newhome.en,
      ucLanding: ucLanding.en,
      faq: faq.en,
      leadsForm: leadsForm.en,
      borrowerLanding: borrowerLanding.en,
      dataDeletion: dataDeletion.en,
      login: login.en,
      register: register.en,
      kyb: kyb.en,
      omuDashboard: omuDashboard,
    },
  },
  prevLanguage: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SELECTED_LANGUAGE":
      return { ...state, selected: action.payload };
    case "SET_PREV_LANGUAGE":
      return { ...state, prevLanguage: action.payload };
    default:
      return state;
  }
};

export default reducer;
